import { colors } from 'fitify-ui'
import { phone, tabletPortrait } from 'fitify-ui-landing/src/theme/breakpoints'
import Link from 'next/link'
import styled, { css } from 'styled-components'

export const StyledCard = styled(Link)`
  display: flex;
  overflow: hidden;
  min-width: 0;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  border: 1px solid ${colors.Gray200};
  border-radius: 16px;
  background-color: ${colors.White};
  color: inherit;
  gap: 16px;
  text-decoration: none;
  transition:
    border-color 100ms ease-in-out,
    box-shadow 100ms ease-in-out;

  &:hover {
    border-color: ${colors.Blue200};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  }

  ${tabletPortrait(css`
    padding: 10px;
    gap: 10px;
  `)};

  ${phone(css`
    padding: 8px;
    gap: 8px;
  `)};
`

export const StyledThumbnail = styled.div`
  overflow: hidden;
  width: 120px;
  flex-shrink: 0;
  aspect-ratio: 704 / 504;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ${tabletPortrait(css`
    width: 90px;
  `)};

  ${phone(css`
    width: 72px;
  `)};
`

export const StyledContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
`
